import ReactGA from "react-ga";

class gaUtility {
  constructor() {
    // ReactGA.initialize("***********", {
    //   gaOptions: {
    //     name: "tracker1",
    //     userId: 123,
    //   },
    // });
    // ReactGA.addTrackers("***********");
  }
  gaEvent = (type: string, value: string) => {
    ReactGA.event({
      category: type,
      action: value,
    });
  };
  gaSet = (type: string) => {
    ReactGA.set({ userID: type });
  };
}

export class GA_SINGLETON {
  private static instance: GA_SINGLETON;
  private static ga: gaUtility;

  constructor() {
    GA_SINGLETON.ga = new gaUtility();
  }

  get obj() {
    return GA_SINGLETON.ga;
  }

  static getInst(): GA_SINGLETON {
    if (!this.instance) {
      this.instance = new GA_SINGLETON();
    }
    return this.instance;
  }
}
